import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Input, Output, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ProgressStepperComponent } from 'src/app/shared/components/progress-stepper/progress-stepper.component';
import { PropertyUploadNavigationComponent } from '../property-upload-navigation/property-upload-navigation.component';
import { CmsApiService, FileResponse } from 'src/app/services/cms-api.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, catchError, of } from 'rxjs';

export interface StepFiveData {
  consent:boolean;
  isValid:boolean;
}

@Component({
  selector: 'app-step-five',
  templateUrl: './step-five.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ProgressStepperComponent,
    TranslocoDirective,
    PropertyUploadNavigationComponent,
  ],
})
export class StepFiveComponent {
  @Input() Steps: string[] = [];
  @Input() loading: boolean = false;
  @Input() termsAccepted = false;
  @Output() saveStepFive = new EventEmitter<StepFiveData>();
  @Output() previousButtonClicked = new EventEmitter<void>();
  @Output() onConsestChange = new EventEmitter<boolean>();

  public markdownContent = signal<string | undefined>(``);
  public htmlStr: string = '';

  data:StepFiveData = {consent:false,isValid:false}
  onConsent(event:any){
    console.log(event.target.checked)
    this.data.consent = event.target.checked
    this.data.isValid = event.target.checked
    this.onConsestChange.emit(this.data.consent)
  }

  constructor(private cmsApiService: CmsApiService,private destroyRef: DestroyRef) {}

  ngOnInit() {
    this.cmsApiService
      .getLegalDocument('agency-seller')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((markdownContent: FileResponse) => {
          return markdownContent.data;
        }),
        catchError((error) => {
          console.error('Error fetching:', error);
          this.markdownContent.set(undefined);
          return of(null); // Use `of(null)` to complete the observable
        })
      )
      .subscribe((markdownContent) => {
        if (markdownContent) {
          console.error('markdownContent');
          this.readBlobAsText(markdownContent);
        }
      });
      
      const e = {
        target:{
          checked:this.termsAccepted
        }
      }
      this.onConsent(e)
  }

  readBlobAsText(blob: Blob) {
    const reader = new FileReader();
    reader.onload = () => {
      this.markdownContent.set(reader.result as string); // Set the read content to a string
      this.htmlStr = reader.result as string;
    };
    reader.readAsText(blob); // Read the blob as text
  }

  saveStep() {
    this.saveStepFive.emit({...this.data});
  }
}
